// HTTP Status Codes
export const HTTP_STATUS = {
  CONFLICT: 409,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
};

// Toast / UI timing
export const COPY_FEEDBACK_MS = 2000;

// Recharts shared styles (memoized as module constants)
export const CHART_TOOLTIP_STYLE = {
  backgroundColor: '#0A0A0A',
  border: '1px solid rgba(255,255,255,0.1)',
  borderRadius: '8px',
};

export const CHART_LINE_DOT = { fill: '#2563EB', r: 4 };
export const CHART_BAR_RADIUS = [8, 8, 0, 0];
